/*
MIT LICENSE
Copyright (c) 2020-present Alibaba Cloud Design
Copied from 'antd/components/breadcrumb/Breadcrumbitem'
Copyright (c) 2015-present Ant UED, https://xtech.antfin.com/

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. */
import React from 'react';
import Dropdown from '../dropdown';
import { Icon } from '../icon';
import { ConfigContext } from '../config-provider';
// Icon and dropdownProps has been changed.
const BreadcrumbItem = ({ prefixCls: customizePrefixCls, separator = React.createElement(Icon, { type: 'slash' }), children, overlay, disabled, dropdownProps, ...restProps }) => {
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
    /** If overlay is have Wrap a DropDown */
    const renderBreadcrumbNode = (breadcrumbItem) => {
        if (overlay) {
            return (React.createElement(Dropdown, { overlay: overlay, placement: 'bottom', overlayClassName: `${prefixCls}-dropdown`, ...dropdownProps },
                React.createElement("span", { className: `${prefixCls}-overlay-link` },
                    breadcrumbItem,
                    React.createElement(Icon, { type: 'chevron--down', className: `${prefixCls}-dropdown-icon` }))));
        }
        return breadcrumbItem;
    };
    let link;
    if ('href' in restProps) {
        link = (React.createElement("a", { className: `${prefixCls}-link`, ...restProps }, children));
    }
    else {
        link = (React.createElement("span", { className: `${prefixCls}-link`, ...restProps }, children));
    }
    // wrap to dropDown
    link = renderBreadcrumbNode(link);
    if (children) {
        return (React.createElement("li", { className: disabled ? `${prefixCls}-disabled` : '' },
            link,
            separator && React.createElement("span", { className: `${prefixCls}-separator` }, separator)));
    }
    return null;
};
BreadcrumbItem.__ANT_BREADCRUMB_ITEM = true;
BreadcrumbItem.displayName = 'BreadcrumbItem';
// const ConfiguredBreadcrumbItem = withConfigProvider(BreadcrumbItem);
// export { ConfiguredBreadcrumbItem as BreadcrumbItem };
// export default ConfiguredBreadcrumbItem;
export default BreadcrumbItem;
